export default defineNuxtRouteMiddleware((to) => {
  const { gameId, lotteryId } = to.params
  if (!useIsMergedLotteryPage(gameId ?? lotteryId)) return

  const localePath = useLocalePath()
  const path = gameId ? `/keno/${gameId}` : `/${lotteryId}`

  return navigateTo(localePath({ path: path.toLowerCase(), query: to.query, hash: to.hash }), {
    replace: true,
    redirectCode: 302,
  })
})
